import {
  UPDATE_GRID_FILTER,
  RESET_FILTERS,
  POPULATE_ALUMNI,
  SET_LOADING,
  SET_ACTIVE_USER,
  POPULATE_CONTEXT,
  POPULATE_TAGS,
  POPULATE_ROSTERS,
  POPULATE_SURVEYS,
  POPULATE_ALUMNI_LANDING_PAGE_INFO,
  POPULATE_SEARCHED_HIGH_SCHOOLS,
  POPULATE_SEARCHED_HE_SCHOOLS,
  POPULATE_SEARCHED_MAJORS,
  POPULATE_SEARCHED_TAGS,
  POPULATE_SEARCHED_ROSTERS,
  POPULATE_SEARCHED_SURVEYS,
  SET_LOADING_DETAIL,
  POPULATE_ALUM,
  POPULATE_OPTION_CONTEXT,
  ADD_ALUM_DETAILS_TO_GRID,
  SET_ACTIVE_TAB,
  POPULATE_ANALYTICS_CONTEXT,
  POPULATE_HE_SCHOOL_LIST_ANALYTICS,
  POPULATE_NSC_INFO,
  SET_ALUMNI_DATABASE_HASH,
} from './constants';

export default (
  state = {
    loading: true,
    loadingDetail: false,
    activeTab: 1,
    landingPage: {},
    gridFilters: {
      search: '',
      sortField: 'last_name',
      sortDirection: 'asc',
      limit: 10,
      offset: 0,
      alumniHash: undefined,
      sectionName: undefined,
      segmentTitle: undefined,
    },
    activeUser: null,
    searchTerm: '',
    searchedMajors: [],
    searchedHESchools: [],
    searchedHighSchools: [],
    searchedTags: [],
    searchedRosters: [],
    searchedSurveys: [],
    results: {
      count: 0,
    },
    options: {},
    context: {},
    analyticsPageContext: undefined,
    heschoolListAnalytics: undefined,
    nscReportsInfo: [],
    isSubscribedToNscReport: false,
  },
  action,
) => {
  switch (action.type) {
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.tab,
      };
    case ADD_ALUM_DETAILS_TO_GRID:
      return {
        ...state,
        results: {
          ...state.results,
          results: state.results?.results?.map(alum =>
            alum.uuid === state.activeUser?.uuid ? state?.activeUser : alum,
          ),
        },
      };
    case POPULATE_OPTION_CONTEXT:
      return {
        ...state,
        options: action.context,
      };
    case SET_LOADING_DETAIL:
      return {
        ...state,
        loadingDetail: action.loading,
      };
    case POPULATE_ALUM:
      return {
        ...state,
        activeUser: action.alum,
      };
    case SET_ACTIVE_USER:
      return {
        ...state,
        activeUser: action.user,
      };
    case POPULATE_SEARCHED_MAJORS:
      return {
        ...state,
        searchedMajors: action.majors,
        searchTerm: action.searchTerm,
      };
    case POPULATE_SEARCHED_HE_SCHOOLS:
      return {
        ...state,
        searchedHESchools: action.schools,
        searchTerm: action.searchTerm,
      };
    case POPULATE_SEARCHED_HIGH_SCHOOLS:
      return {
        ...state,
        searchedHighSchools: action.schools,
        searchTerm: action.searchTerm,
      };
    case POPULATE_SEARCHED_TAGS:
      return {
        ...state,
        searchedTags: action.tags,
        searchTerm: action.searchTerm,
      };
    case POPULATE_SEARCHED_ROSTERS:
      return {
        ...state,
        searchedRosters: action.rosters,
        searchTerm: action.searchTerm,
      };
    case POPULATE_SEARCHED_SURVEYS:
      return {
        ...state,
        searchedSurveys: action.surveys,
        searchTerm: action.searchTerm,
      };
    case POPULATE_ALUMNI_LANDING_PAGE_INFO:
      return {
        ...state,
        landingPage: {
          ...state.landingPage,
          ...action.info,
        },
      };
    case POPULATE_ALUMNI:
      return {
        ...state,
        results: action.alumni,
      };
    case POPULATE_CONTEXT:
      return {
        ...state,
        context: action.context,
      };
    case POPULATE_TAGS:
      return {
        ...state,
        context: {
          ...state.context,
          tags: action.context,
        },
      };
    case POPULATE_ROSTERS:
      return {
        ...state,
        context: {
          ...state.context,
          rosters: action.context,
        },
      };
    case POPULATE_SURVEYS:
      return {
        ...state,
        context: {
          ...state.context,
          surveys: action.context,
        },
      };
    case RESET_FILTERS:
      return {
        ...state,
        gridFilters: {
          search: '',
          sortField: 'last_name',
          sortDirection: 'asc',
          limit: 10,
          offset: 0,
        },
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case UPDATE_GRID_FILTER:
      return {
        ...state,
        gridFilters: {
          ...state.gridFilters,
          ...action.filter,
        },
      };
    case POPULATE_ANALYTICS_CONTEXT:
      return {
        ...state,
        analyticsPageContext: action.data,
      };
    case POPULATE_HE_SCHOOL_LIST_ANALYTICS:
      return {
        ...state,
        heschoolListAnalytics: action.data,
      };
    case POPULATE_NSC_INFO:
      return {
        ...state,
        nscReportsInfo: action.data,
        isSubscribedToNscReport: action.isSubscribedToNscReport,
      };
    case SET_ALUMNI_DATABASE_HASH:
      return {
        ...state,
        gridFilters: {
          search: '',
          sortField: 'last_name',
          sortDirection: 'asc',
          limit: 10,
          offset: 0,
          alumniHash: action.data.alumniHash,
          sectionName: action.data.sectionName,
          segmentTitle: action.data.segmentTitle,
        },
      };
    default:
      return state;
  }
};
